// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1ykwM","colMin":"styles_colMin__3MWOq","colCheckbox":"styles_colCheckbox__2rv5I"};